import React from 'react';
import { Link } from 'react-router-dom';

export function PrivacyPolicy() {
  return (
    <div style={{maxWidth: 700, 
          margin: '2rem auto', 
           borderRadius: 12, 
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem 2rem'}}>

      <h1>Privacy Policy for The Personal Trainers Club</h1>
      <p><b>Effective Date:</b> September 16, 2025</p>
      <h2>1. Introduction</h2>
      <p>
        Welcome to The Personal Trainers Club ("PTC," "we," "our," or "us"). We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.
      </p>
      <h2>2. Information We Collect</h2>
      <ul>
        <li>
          <b>Personal Information:</b>
          <ul>
            <li>Account information (name, email, password)</li>
            <li>Profile information (fitness goals, photos, biographical information)</li>
            <li>Payment information (processed through secure third-party providers)</li>
          </ul>
        </li>
        <li>
          <b>Fitness Data:</b>
          <ul>
            <li>Physical fitness metrics</li>
            <li>Workout history and performance</li>
            <li>Fitness goals and limitations</li>
          </ul>
        </li>
        <li>
          <b>Usage Information:</b>
          <ul>
            <li>Analytics data through Hotjar and Google Analytics</li>
            <li>Device information and IP address</li>
            <li>Usage patterns and preferences</li>
          </ul>
        </li>
        <li>
          <b>Custom Analytics Data:</b>
          <ul>
            <li>Session identifiers stored in your browser (localStorage)</li>
            <li>Access tokens (if available) for authentication and analytics</li>
            <li>Usage events and interaction data collected to improve platform functionality.</li>
          </ul>
        </li>
      </ul>
      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>
          <b>Service Provision:</b>
          <ul>
            <li>Creating and managing your account</li>
            <li>Facilitating trainer-client relationships</li>
            <li>Processing payments and subscriptions</li>
          </ul>
        </li>
        <li>
          <b>Platform Improvement:</b>
          <ul>
            <li>Enhancing user experience</li>
            <li>Developing new features</li>
            <li>Training our AI systems to provide personalized workout recommendations</li>
          </ul>
        </li>
        <li>
          <b>Analytics:</b>
          <ul>
            <li>Using Hotjar to understand user behavior</li>
            <li>Employing Google Analytics to measure performance</li>
            <li>Creating aggregated insights about platform usage</li>
          </ul>
        </li>
        <li>
          <b>Custom Analytics:</b>
          <ul>
            <li>Tracking session activity and usage patterns to enhance platform performance and security</li>
            <li>Associating session IDs and access tokens with usage events for internal analysis</li>
            <li>Ensuring compliance with security and fraud prevention requirements</li>
          </ul>
        </li>
      </ul>
      <h2>4. Information Sharing</h2>
      <ul>
        <li>
          <b>With Other Users:</b>
          <ul>
            <li>Trainer profiles are visible to potential clients</li>
            <li>Client information is shared only with their assigned trainers</li>
            <li>User-generated content may be visible based on your privacy settings</li>
          </ul>
        </li>
        <li>
          <b>With Service Providers:</b>
          <ul>
            <li>Payment processors to complete transactions</li>
            <li>Analytics providers (Hotjar, Google) to improve our services</li>
            <li>Cloud hosting providers to store data securely</li>
          </ul>
        </li>
        <li>
          <b>Legal Requirements:</b>
          <ul>
            <li>To comply with applicable laws</li>
            <li>To respond to legal process</li>
            <li>To protect our rights, privacy, safety, or property</li>
          </ul>
        </li>
      </ul>
      <h2>5. Your Choices and Rights</h2>
      <ul>
        <li>
          <b>Account Settings:</b>
          <ul>
            <li>Control profile visibility and content sharing</li>
            <li>Manage notification preferences</li>
            <li>Update or correct your personal information</li>
          </ul>
        </li>
        <li>
          <b>Legal Rights (varies by jurisdiction):</b>
          <ul>
            <li>Access your personal information</li>
            <li>Request deletion of your data</li>
            <li>Data portability options</li>
            <li>Withdraw consent for processing</li>
          </ul>
        </li>
        <li>
          <b>Custom Analytics Data:</b>
          <ul>
            <li>You may request deletion of your session identifier and analytics data by contacting us</li>
            <li>You can clear your browser's localStorage to remove stored session IDs and access tokens</li>
            <li>We do not use custom analytics data for advertising or third-party marketing</li>
          </ul>
        </li>
      </ul>
      <h2>6. Data Security</h2>
      <p>
        We implement standard encryption and access controls to protect your information from unauthorized access, disclosure, alteration, and destruction.
      </p>
      <h2>7. International Data Transfers</h2>
      <p>
        Your information may be transferred to and processed in countries other than your residence. We ensure appropriate safeguards are in place to comply with cross-border data protection laws.
      </p>
      <h2>8. Children's Privacy</h2>
      <p>
        Our services are not directed to individuals under 18. We do not knowingly collect personal information from children.
      </p>
      <h2>9. Disclaimers</h2>
      <ul>
        <li>
          <b>Trainer Certification:</b>
          <ul>
            <li>We do not verify the certification or qualifications of trainers</li>
            <li>Users should independently verify trainer credentials</li>
            <li>We are not responsible for misrepresentations by trainers</li>
          </ul>
        </li>
        <li>
          <b>Workout Safety:</b>
          <ul>
            <li>Exercise carries inherent risks</li>
            <li>We are not responsible for injuries resulting from workouts</li>
            <li>Users should consult healthcare providers before beginning any exercise program</li>
          </ul>
        </li>
        <li>
          <b>Fitness Data Disclaimer:</b>
          <ul>
            <li>PTC is not a healthcare provider and does not offer medical advice.</li>
            <li>Users should consult qualified healthcare professionals for medical concerns.</li>
            <li>Fitness data collected by PTC is for informational purposes only and should not be used as a substitute for professional medical advice.</li>
          </ul>
        </li>
      </ul>
      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy periodically. We will notify you of significant changes through the platform or via email.
      </p>
      <h2>11. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, please contact us at <a href="mailto:info@heldsolutionsllc.net">info@heldsolutionsllc.net</a>.
      </p>
      <h2>12. Client Data Protection</h2>
      <p>
        We prioritize the protection of client data by implementing encryption, secure storage, and access controls. While we strive for robust security, no system is completely immune to breaches.
      </p>
      <h2>13. Misuse of Platform</h2>
      <p>
        Users are prohibited from engaging in activities that compromise the integrity or security of the platform. Violations may result in account suspension or termination.
      </p>
      <h2>14. Security Measures</h2>
      <p>
        We employ industry-standard security measures, including encryption and regular audits, to protect your data. Users are responsible for safeguarding their account credentials.
      </p>
      <h2>15. Content Guidelines</h2>
      <ul>
        <li>Users must ensure that content shared on the platform complies with applicable laws and does not infringe on the rights of others.</li>
        <li>PTC reserves the right to remove content that violates these guidelines.</li>
      </ul>
      <h2>16. GDPR Compliance</h2>
      <ul>
        <li><b>Data Subject Rights:</b> You have the right to access, rectify, erase, restrict processing, and object to processing of your personal data. You may also request data portability.</li>
        <li><b>Legal Basis:</b> We process your data based on your consent, contract performance, or legitimate interests.</li>
        <li><b>Data Retention:</b> We retain your data for as long as necessary to fulfill the purposes outlined in this policy or comply with legal obligations.</li>
        <li><b>International Transfers:</b> If your data is transferred outside the EU, we ensure appropriate safeguards are in place, such as Standard Contractual Clauses.</li>
      </ul>
      <h2>17. CCPA Compliance</h2>
      <ul>
        <li><b>Consumer Rights:</b> California residents have the right to know what personal information we collect, delete their data, opt-out of its sale, and not face discrimination for exercising these rights.</li>
        <li><b>Categories of Data:</b> We collect personal information such as identifiers, commercial information, and internet activity for the purposes described in this policy.</li>
        <li><b>Do Not Sell My Personal Information:</b> We do not sell personal information. If this changes, we will provide a mechanism to opt-out.</li>
      </ul>
      <h2>18. Data Retention</h2>
      <p>
        We retain your data for up to one year or as long as necessary to fulfill the purposes outlined in this policy. After this period, data is securely deleted unless required for legal or regulatory compliance.
      </p>
      <h2>19. Third-Party Sharing</h2>
      <p>
        We use Google Analytics, Hotjar, and our own custom analytics system to collect usage data and improve our services. Our custom analytics may collect session identifiers, access tokens, and usage events. These tools may collect information such as device details, IP address, and user behavior. You can opt-out of certain tracking through your browser settings or by visiting the respective opt-out pages for <a href="https://tools.google.com/dlpage/gaoptout">Google Analytics</a> and <a href="https://www.hotjar.com/legal/compliance/opt-out">Hotjar</a>. For custom analytics, you may contact us to request deletion of your session data.
      </p>
      <h2>20. Medical Advice and Health Information</h2>
      <p>
        PTC does not collect or process protected health information as defined by healthcare regulations. Any medical advice provided by trainers is their sole responsibility, and users should consult licensed healthcare professionals for medical concerns.
      </p>
    </div>
  );
}